import './header.styles';

import { transitionTurn, setClassIf, showModal } from '@/scripts/utils/base';

/** @typedef {'default'|'transparent-on-top'} Mode */

/** @param {Mode} mode */
export default function initHeader(mode = 'default') {
   const $header = document.querySelector('.header-js');
   const $headerMenu = $header.querySelector('.header-menu-js');
   const $mobileMenuContent = document.querySelector('.mobile-menu-content-js');

   let mobileMenuInitialized = false;

   if (mode === 'transparent-on-top') {
      initTransparentOnTop();
   }

   initEvents();

   function initEvents() {
      document.body.addEventListener('click', (e) => {
         if (!e.target.closest('.open-mobile-menu-js')) return;
         e.preventDefault();
         openMobileMenu();
      });
   }

   function openMobileMenu() {
      initMobileMenu();
      showModal('mobile-menu');
   }

   function initMobileMenu() {
      if (mobileMenuInitialized) return;
      mobileMenuInitialized = true;

      $mobileMenuContent.appendChild($headerMenu.cloneNode(true));

      $mobileMenuContent.querySelectorAll('.header-menu--group')
         .forEach(group => group.removeAttribute('tabindex'));
   }

   function initTransparentOnTop() {
      const offset = 50;
      let frameId = 0;

      transitionTurn.off($header);
      updateTransparency(offset);
      transitionTurn.on($header);

      document.addEventListener('scroll', () => {
         if (frameId) cancelAnimationFrame(frameId);

         frameId = requestAnimationFrame(() => {
            updateTransparency(offset);
         });
      });
   }

   function updateTransparency(offset) {
      setClassIf($header, 'header__transparent', pageYOffset < offset);
   }
}